import { render, staticRenderFns } from "./Doll.vue?vue&type=template&id=1ae00ab8&scoped=true&"
import script from "./Doll.vue?vue&type=script&lang=js&"
export * from "./Doll.vue?vue&type=script&lang=js&"
import style0 from "./Doll.vue?vue&type=style&index=0&id=1ae00ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae00ab8",
  null
  
)

export default component.exports